import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import React from 'react';

import { Grid, Typography } from '@mui/material';

import { modelPath } from '@libs/helpers/form';
import { ConnectedRadioGroup } from '@libs/ui/components/form/radio/Radio';
import { OptionType } from '@libs/ui/components/form/select';
import { ConnectedTextField } from '@libs/ui/components/form/text-field';
import StepSection from '@libs/ui/components/step-section';

import { ApplicationFormState } from '../types';
import ResumeUploader from './ResumeUploader';

interface NameAndGeneralInfoProps {
  showOnlyRequired: boolean;
  cvOptions: OptionType[];
  matchDocuments?:
    | Array<
        | {
            __typename?: 'TalentDocument';
            hash: string;
            title: string;
            type?: any;
          }
        | undefined
      >
    | undefined;
}

const NameAndGeneralInfo: React.FC<NameAndGeneralInfoProps> = ({
  showOnlyRequired,
}) => {
  const { t } = useTranslation('jobForm');

  const VISIBILITY_OPTIONS = [
    { value: 'true', text: t('applicationForm.details.yes') },
    { value: 'false', text: t('applicationForm.details.no') },
  ];

  return (
    <StepSection index={1} title={t('applicationForm.nameAndGeneral.title')}>
      <Grid spacing={4} direction="column" container>
        <Grid item>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <ConnectedTextField
                name={modelPath<ApplicationFormState>(
                  (i) => i.basicInfo.firstName,
                )}
                fullWidth
                variant="filled"
                label={
                  <Typography>
                    {t('applicationForm.nameAndGeneral.firstName')}{' '}
                    <Typography component="span" color="error">
                      *
                    </Typography>
                  </Typography>
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ConnectedTextField
                name={modelPath<ApplicationFormState>(
                  (i) => i.basicInfo.lastName,
                )}
                fullWidth
                variant="filled"
                label={
                  <Typography>
                    {t('applicationForm.nameAndGeneral.lastName')}{' '}
                    <Typography component="span" color="error">
                      *
                    </Typography>
                  </Typography>
                }
              />
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid item>
          <ConnectedDatePicker
            name={modelPath<ApplicationFormState>(
              (i) => i.basicInfo.dateOfBirth,
            )}
            inputFormat="dd/MM/yyyy"
            TextFieldProps={{
              variant: 'filled',
              fullWidth: true,
              label: (
                <Typography>
                  Date of Birth{' '}
                  <Typography component="span" color="error">
                    *
                  </Typography>
                </Typography>
              ),
            }}
          />
        </Grid> */}

        <Grid item>
          <ConnectedTextField
            name={modelPath<ApplicationFormState>(
              (i) => i.basicInfo.jobPostingId,
            )}
            fullWidth
            variant="filled"
            label={
              <Typography>
                {t('applicationForm.nameAndGeneral.job')}{' '}
                <Typography component="span" color="error">
                  *
                </Typography>
              </Typography>
            }
          />
        </Grid>

        {!showOnlyRequired && (
          <>
            <Grid item>
              <Typography variant="body2" gutterBottom>
                {t('applicationForm.nameAndGeneral.visibleForAll')}
              </Typography>
              <ConnectedRadioGroup
                name={modelPath<ApplicationFormState>(
                  (i) => i.basicInfo.visibleToAllBuyers,
                )}
                options={VISIBILITY_OPTIONS}
              />
            </Grid>

            <Grid item>
              <Typography variant="body2" gutterBottom>
                {t('applicationForm.nameAndGeneral.availableToAll')}
              </Typography>
              <ConnectedRadioGroup
                name={modelPath<ApplicationFormState>(
                  (i) => i.basicInfo.availableToAllBuyers,
                )}
                options={VISIBILITY_OPTIONS}
              />
            </Grid>
          </>
        )}

        {/* {alreadyHasCV && (
          <Grid item>
            <ConnectedSelect
              name={modelPath<ApplicationFormState>((i) => i.resume.filename)}
              fullWidth
              variant="filled"
              label="Select Resume / CV"
              options={cvOptions}
              helperText="Choose from existing resumes or upload a new one below"
            />
          </Grid>
        )} */}

        <Grid item>
          <ResumeUploader
            name={modelPath<ApplicationFormState>((i) => i.resume.newCv)}
            showOnlyRequired={showOnlyRequired}
          />
        </Grid>
      </Grid>
    </StepSection>
  );
};

export default NameAndGeneralInfo;
